module.exports = __webpack_public_path__ + "img/organization.7a95a790.svg";